import { css } from 'styled-components';
import Button from '../common/Button';
import { BUTTON_UNIKEY } from '../../define/global';
import { hidePopupAD, usePopupSliceSelector } from '../../store/modules/popup';
import { useDispatch } from 'react-redux';
import closeBtnImg from '../../img/ico_close_ad.png';
import closeBtnImg2X from '../../img/ico_close_ad@2x.png';
import FixedAD, { FIXED_AD_ID } from '../common/FixedAD';
import PopUp from './PopUp';
import { usePOWebofficeSDKState } from '../../context/poWebOfficeSDKContext';

const Position = css`
  right: 26px; // 16(guide) + 10(scroll bar)
  bottom: 41px; // 16(guide) + 25(sdk zoom bar)
  width: 300px;
  height: 250px;
`;

const PopupCloseStyle = css`
  width: 18px;
  height: 18px;
  min-width: 18px;
  position: absolute;
  left: 0px;
  top: 0px;
  border: 0 0 0 0;
  padding: 0 0 0 0;
  background-color: transparent;
  border: none;
`;

export default function PopupAd() {
  const popupSelector = usePopupSliceSelector();
  const poSDKContextState = usePOWebofficeSDKState();
  const dispatch = useDispatch();
  if (!popupSelector.popupAD.isShow) {
    return null;
  }

  const closePopUpAD = () => {
    dispatch(hidePopupAD());
    poSDKContextState.poInstance.handle.activeInput();
  };

  return (
    <PopUp cssExt={Position}>
      <FixedAD id={FIXED_AD_ID.IN_BODY_POPUP} />
      <Button
        cssExt={PopupCloseStyle}
        uniKey={BUTTON_UNIKEY.POPUP_AD_CLOSE_BTN}
        onClick={closePopUpAD}>
        <img
          width="18px"
          height="18px"
          src={closeBtnImg}
          srcSet={closeBtnImg2X}
          alt="ad close button"
        />
      </Button>
    </PopUp>
  );
}
